import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';

import { CardContent as MuiCardContent, CardHeader, IconButton, Theme } from '@mui/material';

import { spacing } from '@mui/system';

import { MoreVertical } from 'react-feather';

import { VectorMap } from 'react-jvectormap';

import '../../../vendor/jvectormap.css';
import { MinimalCard } from 'components/styled';

const MapContainer = styled.div`
  height: 344px;
`;

const CardContent = styled(MuiCardContent)`
  &:last-child {
    padding-top: 0;
    padding-bottom: ${(props) => props.theme.spacing(4)}px;
  }
`;

/**
 * WorldMap component using react-jvectormap
 *
 * ⚠️ KNOWN THIRD-PARTY LIBRARY WARNINGS:
 * This component uses react-jvectormap which has not been updated for React 18.
 * The following warnings are from the third-party library and cannot be fixed without
 * either updating/forking the library or replacing it entirely:
 *
 * 1. "Support for string refs will be removed" - The library uses deprecated string refs
 * 2. "componentWillMount has been renamed" - The library uses deprecated lifecycle methods
 *
 * These warnings are safe to ignore as they are React 18 strict mode warnings for deprecated
 * patterns that still work but will be removed in a future React version.
 *
 * Alternatives to consider:
 * - react-simple-maps (more actively maintained)
 * - react-svg-map
 * - Or remove this component if not critical to functionality
 *
 * @see https://github.com/kadoshms/react-jvectormap/issues - Library is not actively maintained
 */
function WorldMap() {
  const theme = useTheme();
  const options = {
    map: 'world_mill',
    regionStyle: {
      initial: {
        fill: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : '#e3eaef',
      },
    },
    backgroundColor: 'transparent',
    containerStyle: {
      width: '100%',
      height: '100%',
    },
    markerStyle: {
      initial: {
        r: 9,
        fill: theme.palette.secondary.main,
        'fill-opacity': 1,
        stroke: '#fff',
        'stroke-width': 7,
        'stroke-opacity': 0.4,
      },
      hover: {
        stroke: '#fff',
        'fill-opacity': 1,
        'stroke-width': 1.5,
      },
    },
    zoomOnScroll: false,
    markers: [
      {
        latLng: [39.904202, 116.407394],
        name: 'Beijing',
      },
      {
        latLng: [28.70406, 77.102493],
        name: 'Delhi',
      },
      {
        latLng: [41.00824, 28.978359],
        name: 'Istanbul',
      },
      {
        latLng: [40.7127837, -74.0059413],
        name: 'New York',
      },
      {
        latLng: [34.052235, -118.243683],
        name: 'Los Angeles',
      },
      {
        latLng: [41.878113, -87.629799],
        name: 'Chicago',
      },
      {
        latLng: [51.507351, -0.127758],
        name: 'London',
      },
      {
        latLng: [55.755825, 37.617298],
        name: 'Moscow',
      },
      {
        latLng: [40.416775, -3.70379],
        name: 'Madrid',
      },
    ],
  };

  return (
    <MinimalCard $hoverEffect={false} sx={{ mb: 4 }}>
      <CardHeader
        action={
          <IconButton aria-label="settings">
            <MoreVertical />
          </IconButton>
        }
        title="Real-Time"
      />
      <CardContent>
        <MapContainer>
          <VectorMap {...options} />
        </MapContainer>
      </CardContent>
    </MinimalCard>
  );
}

export default WorldMap;
